import React from 'react';
interface FooterProps {
  onOpenPolicy: (policy: 'privacy' | 'refund' | 'shipping') => void;
}
export function Footer({
  onOpenPolicy
}: FooterProps) {
  const currentYear = new Date().getFullYear();
  return <footer className="py-12 px-6 border-t border-gray-100" data-id="element-61">
      <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-62">
        <nav className="flex items-center justify-center gap-8" data-id="element-63">
          <button onClick={() => onOpenPolicy('privacy')} className="text-sm text-gray-600 hover:text-gray-900 transition-colors" data-id="element-64">
            Privacy
          </button>
          <button onClick={() => onOpenPolicy('refund')} className="text-sm text-gray-600 hover:text-gray-900 transition-colors" data-id="element-65">
            Refund Policy
          </button>
          <button onClick={() => onOpenPolicy('shipping')} className="text-sm text-gray-600 hover:text-gray-900 transition-colors" data-id="element-66">
            Shipping
          </button>
        </nav>
        <p className="text-xs text-gray-400 font-light" data-id="element-67">
          © {currentYear} The Candle.
        </p>
      </div>
    </footer>;
}